import axios from 'axios'

import { handleErrorAndGenerateMessage } from '../../../functions/errorHandling'
import { getServerUrl } from '../../../functions/getServerUrl'

const defaultState = {
	incompleteCharts: [],
	fetchingIncompleteCharts: false,

	unapprovedCharts: [],
	fetchingUnapprovedCharts: false,

	chartsNeedingRevision: [],
	fetchingChartsNeedingRevision: false,

	fetchingApprovedCharts: false,
	approvedCharts: [],

	fetchingChartsNeedingValidation: false,
	chartsNeedingValidation: {},

	fetchingAllSiteSubmittedCharts: false,
	allSiteSubmittedCharts: {},

	fetchingAllRegionCharts: false,
	allRegionCharts: {},

  fetchingChartsNeedingVerificationForDataManager: false,
  chartsNeedingVerificationForDataManager: [],

	fetchingChartCounts: false,
	chartCounts: {},
}

export default function chartsReducer(state = defaultState, action) {
	switch (action.type) {
		case "FETCHING_INCOMPLETE_CHARTS":
			return { ...state, fetchingIncompleteCharts: true }
		case "SET_INCOMPLETE_CHARTS":
			return { ...state, fetchingIncompleteCharts: false, incompleteCharts: action.payload }
		case "FETCHING_UNAPPROVED_CHARTS":
			return { ...state, fetchingUnapprovedCharts: true }
		case "SET_UNAPPROVED_CHARTS":
			return { ...state, fetchingUnapprovedCharts: false, unapprovedCharts: action.payload }
		case "FETCHING_APPROVED_CHARTS":
			return { ...state, fetchingApprovedCharts: true }
		case "SET_APPROVED_CHARTS":
			return { ...state, fetchingApprovedCharts: false, approvedCharts: action.payload }
		case "FETCHING_CHARTS_NEEDING_REVISION":
			return { ...state, fetchingChartsNeedingRevision: true }
		case "SET_CHARTS_NEEDING_REVISION":
			return { ...state, fetchingChartsNeedingRevision: false, chartsNeedingRevision: action.payload }
		case "FETCHING_CHARTS_NEEDING_VALIDATION":
		  return { ...state, fetchingChartsNeedingValidation: true }
		case "SET_CHARTS_NEEDING_VALIDATION":
		  return { ...state, fetchingChartsNeedingValidation: false, chartsNeedingValidation: action.payload }
		case "FETCHING_ALL_SUBMITTED_CHARTS_FOR_SITE":
			return { ...state, fetchingAllSiteSubmittedCharts: true }
		case "SET_ALL_SUBMITTED_CHARTS_FOR_SITE":
			return { ...state, fetchingAllSiteSubmittedCharts: false, allSiteSubmittedCharts: action.payload }
		case "FETCHING_ALL_REGION_CHARTS":
			return { ...state, fetchingAllRegionCharts: true }
		case "SET_ALL_CHARTS_FOR_REGION":
			return { ...state, fetchingAllRegionCharts: false, allRegionCharts: action.payload }
		case "FETCHING_CHARTS_WHERE_DATA_MANAGER_ASKED_FOR_VERIFICATION_OR_REVISIONS":
			return { ...state, fetchingChartsNeedingVerificationForDataManager: true }
		case "SET_CHARTS_WHERE_DATA_MANAGER_ASKED_FOR_VERIFICATION_OR_REVISIONS":
      return {
        ...state, 
        fetchingChartsNeedingVerificationForDataManager: false, 
        chartsNeedingVerificationForDataManager: action.payload 
      }
		case "FETCHING_CHART_COUNTS":
			return { ...state, fetchingChartCounts: true }
		case "SET_CHART_COUNTS":
			return { ...state, fetchingChartCounts: false, chartCounts: action.payload }
		case "CHART_HAS_BEEN_DELETED":
			return { ...state, ...getStateAfterChartDeleted(state, action.payload) }
		default:
			return state
	}
}


const getStateAfterChartDeleted = (state, url) => {
	let { incompleteCharts, unapprovedCharts, chartsNeedingRevision, approvedCharts } = state

	if (incompleteCharts) {
		incompleteCharts = filterCharts(incompleteCharts, 'url', url)
	}

	if (unapprovedCharts) {
		unapprovedCharts = filterCharts(unapprovedCharts, 'url', url)
	}

	if (chartsNeedingRevision) {
		chartsNeedingRevision = filterCharts(chartsNeedingRevision, 'url', url)
	}

	if (approvedCharts) {
		approvedCharts = filterCharts(approvedCharts, 'url', url)
	}

	return { incompleteCharts, unapprovedCharts, chartsNeedingRevision, approvedCharts }
}


const filterCharts = (charts, keyName, value) => {
	return charts.filter(chart => chart[keyName] !== value)
}


// ==============================================
// Incomplete Charts
// ==============================================

const fetchingIncompleteCharts = () => {
	return { type: "FETCHING_INCOMPLETE_CHARTS" }
}

const setIncompleteCharts = (charts) => {
	return { type: "SET_INCOMPLETE_CHARTS", payload: charts }
}


export const getIncompleteCharts = (alert) => {
	return (dispatch) => {
		dispatch(fetchingIncompleteCharts())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/incomplete/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
			.then(response => {
				dispatch(setIncompleteCharts(response.data))
			})
			.catch(error => {
				dispatch(setIncompleteCharts([]))
				const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
				if (alert && message) {
					alert.show(message)
				}
			})
	}
}


// ==============================================
// Unapproved Charts
// ==============================================



const fetchingUnapprovedCharts = () => {
	return { type: "FETCHING_UNAPPROVED_CHARTS" }
}

const setUnapprovedCharts = (charts) => {
	return { type: "SET_UNAPPROVED_CHARTS", payload: charts }
}


export const getUnapprovedCharts = (alert) => {
	return (dispatch) => {
		dispatch(fetchingUnapprovedCharts())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/unapproved/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
			.then(response => {
				dispatch(setUnapprovedCharts(response.data))
			})
			.catch(error => {
				dispatch(setUnapprovedCharts([]))
				const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
				if (alert && message) {
					alert.show(message)
				}
			})
	}
}




// ==============================================
// Approved Charts
// ==============================================



const fetchingApprovedCharts = () => {
	return { type: "FETCHING_APPROVED_CHARTS" }
}

const setApprovedCharts = (charts) => {
	return { type: "SET_APPROVED_CHARTS", payload: charts }
}


export const getApprovedCharts = (alert) => {
	return (dispatch) => {
		dispatch(fetchingApprovedCharts())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/approved/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
			.then(response => {
				dispatch(setApprovedCharts(response.data))
			})
			.catch(error => {
				dispatch(setApprovedCharts([]))
				const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
				if (alert && message) {
					alert.show(message)
				}
			})
	}
}


// ==============================================
// Charts Needing Revision
// ==============================================



const fetchingChartsNeedingRevision = () => {
	return { type: "FETCHING_CHARTS_NEEDING_REVISION" }
}

const setChartsNeedingRevision = (charts) => {
	return { type: "SET_CHARTS_NEEDING_REVISION", payload: charts }
}


export const getChartsNeedingRevision = (alert) => {
	return (dispatch) => {
		dispatch(fetchingChartsNeedingRevision())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/requires_revisions/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
			.then(response => {
				dispatch(setChartsNeedingRevision(response.data))
			})
			.catch(error => {
				dispatch(setChartsNeedingRevision([]))
				const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
				if (alert && message) {
					alert.show(message)
				}
			})
	}
}



// ==============================================
// Charts Needing Validation
// ==============================================



const fetchingChartsNeedingValidation = () => {
  return { type: "FETCHING_CHARTS_NEEDING_VALIDATION" }
}

const setChartsNeedingValidation = (charts) => {
  return { type: "SET_CHARTS_NEEDING_VALIDATION", payload: charts }
}


export const getChartsNeedingValidation = (alert) => {
	return (dispatch) => {
		dispatch(fetchingChartsNeedingValidation())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/requires_validation/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
		.then(response => {
			dispatch(setChartsNeedingValidation(response.data))
		})
		.catch(error => {
			dispatch(setChartsNeedingValidation({}))
			const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
			if (alert && message) {
				alert.show(message)
			}
		})
	}
}



// ============================================================
// Charts Where Data Manager Asked for Verification/Revisions
// ============================================================



const fetchingChartsNeedingVerificationForDataManager = () => {
  return { type: "FETCHING_CHARTS_WHERE_DATA_MANAGER_ASKED_FOR_VERIFICATION_OR_REVISIONS" }
}

const setChartsNeedingVerificationForDataManager = (charts) => {
  return { type: "SET_CHARTS_WHERE_DATA_MANAGER_ASKED_FOR_VERIFICATION_OR_REVISIONS", payload: charts }
}


export const getChartsNeedingVerificationForDataManager = (alert) => {
  return (dispatch) => {
		dispatch(fetchingChartsNeedingVerificationForDataManager())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/verification_required_by_data_manager/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
		.then(response => {
			dispatch(setChartsNeedingVerificationForDataManager(response.data))
		})
		.catch(error => {
			dispatch(setChartsNeedingVerificationForDataManager([]))
			const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
			if (alert && message) {
				alert.show(message)
			}
		})
	}
}


// ==============================================
// All of a Region's Charts
// ==============================================



const fetchingAllRegionCharts = () => {
	return { type: "FETCHING_ALL_REGION_CHARTS" }
}

const setAllRegionCharts = (charts) => {
	return { type: "SET_ALL_CHARTS_FOR_REGION", payload: charts }
}


export const getAllRegionCharts = (alert) => {
	return (dispatch) => {
		dispatch(fetchingAllRegionCharts())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/all/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
			.then(response => {
				dispatch(setAllRegionCharts(response.data))
			})
			.catch(error => {
				dispatch(setAllRegionCharts({}))
				const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
				if (alert && message) {
					alert.show(message)
				}
			})
	}
}


// ==============================================
// All of a Site's Submitted Charts
// ==============================================



const fetchingAllSiteSubmittedCharts = () => {
	return { type: "FETCHING_ALL_SUBMITTED_CHARTS_FOR_SITE" }
}

const setAllSiteSubmittedCharts = (charts) => {
	return { type: "SET_ALL_SUBMITTED_CHARTS_FOR_SITE", payload: charts }
}


export const getAllSiteSubmittedCharts = (alert) => {
	return (dispatch) => {
		dispatch(fetchingAllSiteSubmittedCharts())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/submitted/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
			.then(response => {
				dispatch(setAllSiteSubmittedCharts(response.data))
			})
			.catch(error => {
				dispatch(setAllSiteSubmittedCharts({}))
				const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
				if (alert && message) {
					alert.show(message)
				}
			})
	}
}


// ==============================================
// Chart Counts
// ==============================================



const fetchingChartCounts = () => {
	return { type: "FETCHING_CHART_COUNTS" }
}

const setChartCounts = (charts) => {
	return { type: "SET_CHART_COUNTS", payload: charts }
}


export const getChartCounts = (alert) => {
	return (dispatch) => {
		dispatch(fetchingChartCounts())

		axios({
			method: "GET",
			url: `${getServerUrl()}/patient-charts/chart_counts/`,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
		})
			.then(response => {
				dispatch(setChartCounts(response.data))
			})
			.catch(error => {
				dispatch(setChartCounts({}))
				const message = handleErrorAndGenerateMessage(error, 'retreiving the charts from the server', dispatch)
				if (alert && message) {
					alert.show(message)
				}
			})
	}
}
